<template>
    <div>
      <v-row no-gutters justify="center" align="center">
        <v-col class="py-0">
          <v-file-input
            multiple
            show-size
            label="Datei wählen"
            :counter-size-string="
              `
                ${currentFiles.filter((o) => o.type.includes('image/')).length}x Bild,
                ${currentFiles.filter((o) => o.type.includes('/pdf')).length}x PDF
              `
            "
            :accept="accept"
            @change="selectFile"
            :key="componentKey"
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0" align="center">
          <v-btn color="success" small @click="upload"
            :disabled="currentFiles.length <= 0"
            :loading="uploading"
          >
            <v-icon left>mdi-cloud-upload</v-icon>
            Hochladen
          </v-btn>
        </v-col>
      </v-row>
      <v-alert
        v-if="message"
        class="mt-3 mb-0 text-left"
        dense
        outlined
        type="error"
      >
        {{ message }}
      </v-alert>
      <!-- <v-card v-if="fileInfos.length > 0" class="mx-auto">
        <v-list>
          <v-subheader>List of Files</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item v-for="(file, index) in fileInfos" :key="index">
              <a :href="file.url">{{ file.name }}</a>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card> -->
    </div>
</template>
<script>
import $ from 'jquery';
import { apiFehlermeldung, sichereApiFehlermeldung } from '@/utils/apiFehler';

export default {
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    apipath: {
      type: String,
      default: 'f400-410/UPLOAD',
    },
    accept: {
      type: String,
      default: 'image/png, image/jpeg, image/bmp',
    },
    sessionInBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentFiles: [],
      progress: 0,
      message: '',
      fileInfos: [],
      uploading: false,
      componentKey: 1,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    selectFile(file) {
      this.progress = 0;
      this.currentFiles = Array.isArray(file) ? file : (file ? [file] : []);
      this.message = '';
      // console.log(this.currentFiles);
    },
    upload() {
      if (this.currentFiles.length <= 0) {
        this.message = 'Bitte eine Datei auswählen';
        return;
      }
      this.message = '';
      this.tryUpload(this.currentFiles);
    },
    async tryUpload(files) {
      this.uploading = true;
      this.message = '';
      const formData = new FormData();
      let i = 1;
      files.forEach((f) => {
        formData.append(`file${i}`, f);
        i += 1;
      });
      if (this.sessionInBody) {
        formData.append('code', this.$store.state.login.session.code);
      }
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/${this.apipath}`,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        timeout: 30000,
        success: (response) => {
          if (response && response.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
            return;
          }
          if (!response || response.status === 'error') {
            this.message = sichereApiFehlermeldung(
              response && response.message,
              'Die Datei konnte nicht hochgeladen werden. Bitte erneut versuchen.',
            );
            return;
          }
          if (!Array.isArray(response.neuDokument) || response.neuDokument.length === 0) {
            this.message = 'Der Upload wurde nicht vollständig gespeichert. Bitte erneut versuchen.';
            return;
          }
          this.$emit('neuDokumente', response.neuDokument);
          // Bestehende Aufrufer behalten das Dokumentarray; Auftragdialoge
          // erhalten zusaetzlich die bestaetigte Zahlungsrevision des Uploads.
          this.$emit('gespeichert', response);
          this.componentKey += 1;
          this.currentFiles = [];
        },
        error: (xhr, textStatus) => {
          if (
            xhr.responseJSON
            && xhr.responseJSON.status === 'accessError'
          ) {
            this.$store.commit('login/backendErrorSession');
            return;
          }
          this.message = apiFehlermeldung(
            xhr,
            textStatus,
            'Die Datei konnte nicht hochgeladen werden. Bitte erneut versuchen.',
          );
        },
        complete: () => {
          this.uploading = false;
        },
      });
    },
  },
};
</script>
